import React from 'react';

/**
 * Reusable section for displaying grouped details
 */
export const DetailSection = ({ title, children, className = '' }) => {
    return (
        <div className={`detail-section ${className}`}>
            <h2 className="section-title">{title}</h2>
            <div className="section-content">
                {children}
            </div>
        </div>
    );
};

export default DetailSection; 